import React from 'react';
import './contact.css';

function Contact() {
  const email = "bogaihelp@gmail.com";
  const subject = "BogAI support message"; 

  
  const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${""}`;
  return (
    <div className='contact_container'>
      <main>
        <div className='contact_header'>
            <h1>
                <strong>Contact Us</strong>
            </h1>
        </div>

        <div className='contact_info'>
            <p>
                <a href={mailtoLink}>Email Us</a>
            </p>
        </div>
        
        <div className='or_container'>
            <h2>OR</h2>
        </div>

        <div className='discord_contact'>
            <p>Use the /feedback command on the bot via discord!</p>
        </div>
      </main>
    </div>
  );
}

export default Contact;